"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = _interopRequireDefault(require("./core"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Router = /*#__PURE__*/function () {
  function Router() {
    _classCallCheck(this, Router);
  }

  _createClass(Router, null, [{
    key: "getRouteError",
    value: function getRouteError() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return route.meta && route.meta.error;
    }
  }, {
    key: "isRouteAnError",
    value: function isRouteAnError() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return !!this.getRouteError(route);
    }
  }, {
    key: "matchedRoutes",
    value: function matchedRoutes() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return [route].concat(route.matched || []);
    }
  }, {
    key: "isRouteAuthenticated",
    value: function isRouteAuthenticated() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!route) {
        throw new Error('RouteUndefined');
      }

      return this.matchedRoutes(route).map(function (routeRow) {
        // By default, a route needs authentication
        var authentication = routeRow.meta && routeRow.meta.authentication; // When authentication is null, it means it's accessible when authentication and when you're not authenticated

        if (authentication === null) {
          return false;
        }

        return typeof authentication === 'boolean' ? authentication : true;
      }, []).some(function (authentication) {
        return authentication === true;
      });
    }
  }, {
    key: "hasAccessToAuthenticatedRoute",
    value: function hasAccessToAuthenticatedRoute() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!route) {
        throw new Error('RouteUndefined');
      } // Check if resource is allowed


      if (this.isResourceTypeAllowedToRoute(route, _core["default"].auth.resource._meta.index) === false) {
        return false;
      } // Check for permissions


      if (this.hasNeededPermissions(route) === false) {
        return false;
      }

      return true;
    }
  }, {
    key: "isResourceTypeAllowedToRoute",
    value: function isResourceTypeAllowedToRoute() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var resource_type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!route) {
        throw new Error('RouteUndefined');
      } // Get route resource type, default is 'users'


      var resourceTypeNeeded = route.meta && route.meta.resource ? route.meta.resource : ['users'];
      if (typeof resourceTypeNeeded === 'string') resourceTypeNeeded = [resourceTypeNeeded]; // Check if resource type is * or same as given resource type

      return resourceTypeNeeded.includes('*') || resourceTypeNeeded.some(function (resourceType) {
        return _core["default"].auth.isResourceFromIndex(resourceType);
      });
    }
  }, {
    key: "hasNeededPermissions",
    value: function hasNeededPermissions() {
      var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!route) {
        throw new Error('RouteUndefined');
      } // Get needed permissions


      var neededPermissions = (route.meta && route.meta.permissions ? route.meta.permissions : []).filter(function (permission) {
        if (permission && _typeof(permission) === 'object' && permission.resource !== _core["default"].auth.resource._meta.index) {
          return false;
        }

        return true;
      }, []).map(function (permission) {
        if (_typeof(permission) === 'object') {
          return permission.permissions;
        }

        return permission;
      }, []).filter(function (item, idx, self) {
        return self.indexOf(item) === idx;
      }, []);
      ; // Validate needed permissions

      return neededPermissions.length === 0 || _core["default"].permissions.hasPermission(neededPermissions);
    }
  }, {
    key: "removeQueryFromRoute",
    value: function removeQueryFromRoute() {
      var router = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!router || !router.currentRoute) {
        throw new Error('InvalidRouter');
      } // Copy query and remove given key


      var query = _objectSpread({}, router.currentRoute.query || {});

      delete query[key];
      router.replace(_objectSpread(_objectSpread({}, router.currentRoute), {}, {
        query: query
      }));
    }
  }]);

  return Router;
}();

exports["default"] = Router;